<template lang="pug">
.checkbox-option(@click='toggle' :style="{ cursor: value.disabled ? 'not-allowed' : 'pointer' }")
    input.checkbox-option-value(:id='value.id', :value='value.id', :checked='value.selecionado', type='checkbox' :disabled='true')
    .checkmark.mdi.mdi-checkbox-marked-outline(v-if='value.selecionado' :style="{ opacity: value.disabled ? '0.5' : '1' }")
    .checkmark.mdi.mdi-checkbox-blank-outline(v-else)
    .checkbox-option-label(v-if='value.nome && mostrarNome') {{ value.nome }}
</template>

<script>
export default {
    name: 'CheckboxInputComponent',
    props: {
        value: {
            type: Object,
            required: true,
        },
        mostrarNome: {
            type: Boolean,
            default: false,
        },
    },

    methods: {

        toggle() {
            if (!this.value?.disabled) {
                this.$set(this.value, 'selecionado', !this.value.selecionado);
                this.$emit('input', this.value);
                this.$emit('click', this.value);
            }
        },
    },
};
</script>

<style lang="scss">
.checkbox-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    margin: 5px 0 5px 0;
}

input[type='checkbox'].checkbox-option-value {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    height: 21px;
    width: 21px;
    background-color: var(--primary-light-green);
}

.checkbox-option:hover input[type='checkbox']~.checkmark {
    background-color: var(--primary-light-green);
}

.checkbox-option input[type='checkbox']:checked~.checkmark {
    background-color: var(--primary-green);
}

.checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

.checkbox-option input[type='checkbox']:checked~.checkmark:after {
    display: block;
}

.checkbox-option-label {
    margin-left: 10px;
}
</style>
